import * as React from 'react';
import styled from 'styled-components';
import { color, space } from '@core-ds/primitives';
import { Bullet } from '@core-ds/icons/16';
import withTippy from './with_tippy';

const Container = styled.div`
   margin: 0 ${space[3]};

   &:last-child {
      margin-right: 0;
   }
`;

const UnstyledButton = styled.a`
   display: inline-block;
   position: relative;
   cursor: pointer;
   overflow: visible;

   svg:first-child {
      transition: color 0.1s;
   }

   :hover {
      text-decoration: none;
      svg:first-child {
         color: ${color.white};
      }

      > div {
         background-color: ${color.white};
      }
   }
`;

const Badge = styled(Bullet)`
   position: absolute;
   top: -8px;
   right: -10px;

   color: ${color.blue.ifixit};
`;

const UnstyledButtonWithTippy = withTippy(UnstyledButton);

type TippyProps = React.ComponentProps<typeof UnstyledButtonWithTippy>;
type DropdownProps = Omit<TippyProps, 'children' | 'content' | 'icon' | 'hasBadge'> & {
   icon: React.ReactNode;
   hasBadge?: boolean;
   children: TippyProps['content'];
};

const Dropdown = ({ id, children, icon, hasBadge, ...tippyOptions }: DropdownProps) => {
   return (
      <Container>
         <UnstyledButtonWithTippy id={id} content={children} {...tippyOptions}>
            {icon}
            {!!hasBadge && <Badge className="headerBadge" />}
         </UnstyledButtonWithTippy>
      </Container>
   );
};

Dropdown.defaultProps = {
   onMount: () => {},
};

export default Dropdown;
